"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EditCycleCount = void 0;
const button_1 = require("client/components/material/button");
const list_1 = require("client/components/material/list");
const list_item_1 = require("client/components/material/list/list-item");
const list_item_text_1 = require("client/components/material/list/list-item/list-item-text");
const text_field_1 = require("client/components/material/text-field");
const ui_1 = require("client/components/ui");
const callable_1 = require("client/components/ui/callable");
const store_1 = require("client/modules/inventory/modules/inventory-list/store");
const store_2 = require("client/modules/sites/modules/sites-detail/store");
const store_3 = require("client/modules/users/store");
const Collapse_1 = require("material-ui/transitions/Collapse");
const mobx_1 = require("mobx");
const mobx_react_1 = require("mobx-react");
const ramda_1 = require("ramda");
const React = require("react");
const react_1 = require("react");
const ReactTooltip = require("react-tooltip");
const uppercase_string_1 = require("shared/util/uppercase-string");
const throttle_debounce_1 = require("throttle-debounce");
require("./edit-cycle-count.less");
const columns = [
    {
        label: "ndc",
        id: "package"
    },
    {
        label: "name",
        id: "name"
    },
    {
        label: "pkg qty/form",
        id: "dosage"
    },
    {
        label: "hand count",
        id: "count"
    }
];
const columnsException = [
    {
        label: "ndc",
        id: "package"
    },
    {
        label: "name",
        id: "name"
    },
    {
        label: "pkg qty/form",
        id: "dosage"
    },
    {
        label: "hand count",
        id: "count"
    },
    {
        label: "actual qty",
        id: "qty"
    }
];
let EditCycleCount = class EditCycleCount extends react_1.Component {
    constructor() {
        super(...arguments);
        this.showChildren = {};
        this.isCollapse = true;
        this.checkedRowId = -1;
        this.editInventoryId = -1;
        this.currentRowIndex = -1;
        this.order = "ASC";
        this.orderBy = "package";
        this.filterText = "";
        this.autoFocusForm = true;
        this.activeSite = store_2.sitesDetailStore.site.value;
        this.siteInventoryCycleCount = new Map();
        this.loadInventory = throttle_debounce_1.debounce(200, async () => {
            const options = {
                count: 100,
                order: this.order,
                search: this.filterText,
                start: 0,
                where: `inventorysite.siteId = ${this.activeSite.id} AND inventorysite.active = true`,
                sort: this.orderBy
            };
            await store_1.inventoryListStore.loadInventory(options);
            this.initializeCycleCount();
        });
        this.loadInventorySiteLots = throttle_debounce_1.debounce(200, async () => {
            const options = {
                count: 100,
                order: "",
                search: "",
                start: 0,
                where: ``,
                sort: "",
                siteId: this.activeSite.id
            };
            await store_1.inventoryListStore.loadInventorySiteLots(options);
        });
        this.initializeCycleCount = () => {
            //
            const { inventory: { value = [] } } = store_1.inventoryListStore;
            this.siteInventoryCycleCount.clear();
            for (const group of value) {
                if (group && group.children && group.children.length) {
                    for (const child of group.children) {
                        this.siteInventoryCycleCount.set(child.id, 0);
                    }
                }
            }
        };
        this.renderGroupedListRow = (row, index) => (React.createElement("div", { key: index },
            React.createElement(list_item_1.MaterialListItem, { category: list_item_1.IListItemCategory.GroupHeader, onClick: () => {
                    this.handleClickGroup(index);
                } },
                React.createElement(list_item_text_1.MaterialListItemText, { groupHeader: true, primary: `${row.group || CONFIG.emptyText}` })),
            React.createElement(Collapse_1.default, { in: this.showChildren[index] !== false },
                React.createElement(list_1.MaterialList, { rows: row.children, renderRow: this.renderGroupedListChild }))));
        this.renderGroupedListChild = (child, index) => {
            const className = this.currentRowIndex === index
                ? "list-component__row edit-active"
                : "list-component__row edit-inactive";
            const inventorysite = child.sites &&
                child.sites.find(inventorysite => inventorysite.inventoryId === child.id);
            return [
                React.createElement(list_item_1.MaterialListItem, { key: index, className: className, onClick: () => this.handleClickChild(child, index) },
                    React.createElement(list_item_text_1.MaterialListItemText, { primary: child.package }),
                    React.createElement(list_item_text_1.MaterialListItemText, { primary: child.strengthDescription || child.name || child.generic }),
                    React.createElement(list_item_text_1.MaterialListItemText, { primary: child.dosage }),
                    React.createElement(list_item_text_1.MaterialListItemText, { primary: React.createElement(text_field_1.MaterialTextField, { className: "blind-count-qty", label: "qty", disabled: !store_3.usersStore.permissions.UpdateCycle, onChange: this.handleSiteInventoryCycleCountChange(child), required: true, type: "number", numType: "integer", value: this.siteInventoryCycleCount &&
                                this.siteInventoryCycleCount.has(child.id)
                                ? this.siteInventoryCycleCount.get(child.id)
                                : 0 }) }))
            ];
        };
        this.renderGroupedListRowException = (row, index) => (React.createElement("div", { key: index },
            React.createElement(list_item_1.MaterialListItem, { category: list_item_1.IListItemCategory.GroupHeader, onClick: () => {
                    this.handleClickGroup(index);
                } },
                React.createElement(list_item_text_1.MaterialListItemText, { groupHeader: true, primary: `${row.group || CONFIG.emptyText}` })),
            React.createElement(Collapse_1.default, { in: this.showChildren[index] !== false },
                React.createElement(list_1.MaterialList, { rows: row.children, renderRow: this.renderGroupedListChildException }))));
        this.renderGroupedListChildException = (child, index) => {
            const className = this.currentRowIndex === index
                ? "list-component__row edit-active"
                : "list-component__row edit-inactive";
            const inventorysite = child.sites &&
                child.sites.find(inventorysite => inventorysite.inventoryId === child.id);
            const inventoryName = child.strengthDescription || child.name || child.generic;
            const dosage = child.dosage || "";
            return [
                React.createElement(list_item_1.MaterialListItem, { key: index, className: className, onClick: () => this.handleClickChild(child, index) },
                    React.createElement(list_item_text_1.MaterialListItemText, { primary: child.package }),
                    React.createElement(list_item_text_1.MaterialListItemText, { primary: uppercase_string_1.uppercaseString(inventoryName) }),
                    React.createElement(list_item_text_1.MaterialListItemText, { primary: uppercase_string_1.uppercaseString(dosage) }),
                    React.createElement(list_item_text_1.MaterialListItemText, { primary: "Blind count" }),
                    React.createElement(list_item_text_1.MaterialListItemText, { primary: "Actual count" }))
            ];
        };
        this.handleSiteInventoryCycleCountChange = (inventory) => (event, value) => {
            if (value === "") {
                this.siteInventoryCycleCount.set(inventory.id, 0);
            }
            else {
                const parsedValue = parseInt(value, 10);
                !isNaN(parsedValue) &&
                    this.siteInventoryCycleCount.set(inventory.id, parsedValue);
            }
        };
        this.renderForm = () => (React.createElement(ui_1.UiForm, { buttons: store_3.usersStore.permissions.UpdateCycle && [
                React.createElement(button_1.MaterialButton, { className: "btnCancel", onClick: this.handleCancel }, "Cancel"),
                "Review"
            ], loading: this.props.loading, isChanged: () => true, 
            // isChanged={this.isChanged}
            // status={this.status}
            status: this.status, saved: "Compared", onSubmit: this.handleSubmit, error: this.props.error },
            React.createElement("div", { className: "inventory__list" }, this.renderGroupedList())));
        this.onRequestSort = (property) => {
            if (this.orderBy === property) {
                this.order === "ASC" ? (this.order = "DESC") : (this.order = "ASC");
            }
            else {
                this.orderBy = property;
                this.order = "ASC";
            }
            this.loadInventory();
        };
        this.isChanged = (inventory) => {
            const site = store_2.sitesDetailStore.site.value;
            if (!site) {
                return false;
            }
            this.status = ui_1.FormStatus.Clean;
            return false;
        };
        this.handleCancel = () => {
            this.props.onCancel();
        };
        this.handleClickGroup = (index) => {
            this.showChildren = ramda_1.merge(this.showChildren, {
                [index]: this.showChildren[index] === false ? true : false
            });
        };
        this.handleClickChild = (child, index) => {
            if (this.editInventoryId === child.id) {
                this.isCollapse = !this.isCollapse;
            }
            else {
                this.isCollapse = false;
            }
            if (this.isChanged(child)) {
                this.status = ui_1.FormStatus.Dirty;
            }
            else {
                this.status = ui_1.FormStatus.Clean;
            }
            this.checkedRowId = -1;
            this.editInventoryId = child.id;
            this.currentRowIndex = index;
        };
        this.onCallback = (value) => {
            this.autoFocusForm = false;
            this.filterText = value;
            this.loadInventory();
        };
        this.handleSubmit = () => {
            callable_1.callable(this.props.onSave)(this.activeSite, this.siteInventoryCycleCount);
        };
    }
    componentWillMount() {
        if (this.activeSite) {
            this.loadInventory();
            this.loadInventorySiteLots();
        }
    }
    componentWillReceiveProps(props) {
        this.activeSite = store_2.sitesDetailStore.site.value;
        this.loadInventory();
        this.loadInventorySiteLots();
        this.status = this.props.status || ui_1.FormStatus.Clean;
    }
    componentDidUpdate() {
        ReactTooltip.rebuild();
    }
    renderGroupedList() {
        const { inventory: { value = [] } } = store_1.inventoryListStore;
        return (React.createElement(list_1.MaterialList, { columns: columns, onRequestSort: this.onRequestSort, order: this.order, orderBy: this.orderBy, rows: value, renderRow: this.renderGroupedListRow, resizableheader: true, customClass: "custom-material-list__cycle-count-list" }));
    }
    renderGroupedListException() {
        const { inventory: { value = [] } } = store_1.inventoryListStore;
        return (React.createElement(list_1.MaterialList, { columns: columnsException, onRequestSort: this.onRequestSort, order: this.order, orderBy: this.orderBy, rows: value, renderRow: this.renderGroupedListRowException, resizableheader: true, customClass: "custom-material-list__cycle-count-list" }));
    }
    render() {
        return (React.createElement(React.Fragment, null,
            React.createElement(ReactTooltip, { id: "warning-icon", className: "tooltip", effect: "solid", place: "left", "data-type": "warning", multiline: true }),
            React.createElement("div", { className: "site-edit-inventory" }, this.renderForm())));
    }
};
__decorate([
    mobx_1.observable
], EditCycleCount.prototype, "showChildren", void 0);
__decorate([
    mobx_1.observable
], EditCycleCount.prototype, "isCollapse", void 0);
__decorate([
    mobx_1.observable
], EditCycleCount.prototype, "status", void 0);
__decorate([
    mobx_1.observable
], EditCycleCount.prototype, "checkedRowId", void 0);
__decorate([
    mobx_1.observable
], EditCycleCount.prototype, "editInventoryId", void 0);
__decorate([
    mobx_1.observable
], EditCycleCount.prototype, "currentRowIndex", void 0);
__decorate([
    mobx_1.observable
], EditCycleCount.prototype, "order", void 0);
__decorate([
    mobx_1.observable
], EditCycleCount.prototype, "orderBy", void 0);
__decorate([
    mobx_1.observable
], EditCycleCount.prototype, "filterText", void 0);
__decorate([
    mobx_1.observable
], EditCycleCount.prototype, "autoFocusForm", void 0);
__decorate([
    mobx_1.observable
], EditCycleCount.prototype, "activeSite", void 0);
__decorate([
    mobx_1.observable
], EditCycleCount.prototype, "siteInventoryCycleCount", void 0);
EditCycleCount = __decorate([
    mobx_react_1.observer
], EditCycleCount);
exports.EditCycleCount = EditCycleCount;



//////////////////
// WEBPACK FOOTER
// ./src/client/modules/stocks/modules/sites-detail/components/edit-cycle-count/edit-cycle-count.tsx
// module id = 4099
// module chunks = 0